import React from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContactSection = () => {
  return (
    <section
      id="contact"
      className="relative bg-gradient-to-br from-black via-gray-900 to-black text-white px-6 py-24 overflow-hidden"
    >
      {/* Decorative shapes behind content */}
      <div className="absolute bg-[#3B3B3B] w-16 h-16 rounded-md left-0 bottom-12 z-0"></div>
      <div className="absolute bg-[#4A242E] w-60 h-60 rounded-full right-5 top-12 z-0 opacity-70"></div>
      <div className="absolute top-20 right-10 w-2 h-2 bg-orange-500 rounded-full z-0"></div>
      <div className="absolute top-40 right-20 w-2 h-2 bg-purple-500 rounded-full z-0"></div>

      <h2 className="text-4xl font-bold mb-6 text-center z-10 relative">Contact Us</h2>
      <p className="text-gray-400 text-lg text-center mb-12 z-10 relative">
        Let’s connect! Whether you have a question, need support, or want to collaborate — we’re just a message away.
      </p>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-12 relative z-10">
        {/* Left Column */}
        <div className="space-y-6">
          <div>
            <h4 className="text-xl font-semibold text-green-400 mb-1">Email</h4>
            <a
              href="mailto:info@pentomino.in"
              className="text-gray-300 text-xl hover:text-green-400 transition"
            >
              <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
              info@pentomino.in
            </a>
          </div>

          <div>
            <h4 className="text-xl font-semibold text-green-400 mb-1">Phone</h4>
            <a
              href="tel:+919632383629"
              className="text-gray-300 text-xl hover:text-green-400 transition"
            >
              <FontAwesomeIcon icon={faPhone} className="mr-2" />
              +91 96323 83629
            </a>
          </div>

          <div>
            <h4 className="text-xl font-semibold text-green-400 mb-1">WhatsApp</h4>
            <a
              href="https://wa.me/919632383629"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 text-xl hover:text-green-400 transition"
            >
              <FontAwesomeIcon icon={faWhatsapp} className="mr-2 text-green-400" />
              +91 96323 83629
            </a>
          </div>

          <div>
            <h4 className="text-xl font-semibold text-green-400 mb-1">Address</h4>
            <a
              href="https://maps.app.goo.gl/4GygfB3oUX8sX1Yp8"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 text-xl hover:text-green-400 transition inline-flex items-start"
            >
              <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2 mt-1" />
              No.10, Hobli Rd, near Muthurayaswami Temple, Vinayaka Layout, 2nd Stage,<br />
              Bengaluru, Karnataka 562130
            </a>
          </div>
        </div>

        {/* Right Column */}
        <div className="relative">
          <form className="bg-gray-900 p-6 rounded-lg shadow-md space-y-6">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full p-3 rounded bg-black border border-gray-700 text-white focus:outline-none focus:border-green-500"
            />
            <input
              type="email"
              placeholder="Your Email"
              className="w-full p-3 rounded bg-black border border-gray-700 text-white focus:outline-none focus:border-green-500"
            />
            <textarea
              rows="5"
              placeholder="Your Message"
              className="w-full p-3 rounded bg-black border border-gray-700 text-white focus:outline-none focus:border-green-500"
            />
            <button
              type="submit"
              className="w-full bg-green-500 hover:bg-green-600 text-black font-semibold py-3 rounded"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
